/* SOLEN — runtime interactions (vanilla, no framework, zero dependency) */

function ready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/* ─── Nav : transparent en haut, verre au scroll ─────────── */
function initNavScroll() {
  const nav = document.querySelector(".dune-nav");
  if (!nav) return;
  const onScroll = () => {
    nav.dataset.scrolled = window.scrollY > 24 ? "true" : "false";
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
}

/* ─── Ripple boutons ─────────────────────────────────────── */
function initRipples() {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".dune-btn");
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    const r = document.createElement("span");
    r.className = "dune-ripple";
    r.style.left = `${e.clientX - rect.left}px`;
    r.style.top = `${e.clientY - rect.top}px`;
    btn.appendChild(r);
    setTimeout(() => r.remove(), 700);
  });
}

/* ─── Reveal on view ─────────────────────────────────────── */
function initRevealOnView() {
  if (!("IntersectionObserver" in window)) {
    document
      .querySelectorAll("[data-dune-reveal]")
      .forEach((el) => el.classList.add("is-revealed"));
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-revealed");
          obs.unobserve(e.target);
        }
      });
    },
    { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
  );
  document
    .querySelectorAll("[data-dune-reveal]")
    .forEach((el) => obs.observe(el));
}

/* ─── Offre « 2 achetés, le 3ème offert » : suit le panier ── */
function updateOffer(count) {
  document.querySelectorAll("[data-dune-offer]").forEach((o) => {
    o.dataset.count = count;
    const msg = o.querySelector("[data-offer-msg]");
    const fill = o.querySelector("[data-offer-fill]");
    if (msg) {
      msg.innerHTML =
        count >= 3 ? "🎉 Votre 3<sup>ème</sup> article est <strong>offert</strong> !"
        : count === 2 ? "Plus qu'<strong>1 article</strong> pour débloquer le 3<sup>ème</sup> offert !"
        : count === 1 ? "Ajoutez <strong>2 articles</strong> et le 3<sup>ème</sup> est offert."
        : "Ajoutez <strong>3 articles</strong> : le moins cher vous est offert.";
    }
    if (fill) fill.style.width = Math.min(100, Math.floor((count * 100) / 3)) + "%";
  });
}

/* ─── Compteur panier ────────────────────────────────────── */
function initCartCount() {
  const counters = document.querySelectorAll("[data-dune-cart-count]");
  if (!counters.length) return;
  fetch("/cart.js", { headers: { Accept: "application/json" } })
    .then((r) => r.json())
    .then((cart) => {
      const count = cart.item_count || 0;
      updateOffer(count);
      counters.forEach((c) => {
        c.textContent = count;
        c.hidden = count === 0;
      });
    })
    .catch(() => {});
}

/* ─── Focus trap générique ───────────────────────────────── */
function trapFocus(container, e) {
  const focusables = container.querySelectorAll(
    'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  if (!focusables.length) return;
  const first = focusables[0];
  const last = focusables[focusables.length - 1];
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
}

/* ─── Menu mobile (burger + drawer) ──────────────────────── */
function initBurgerNav() {
  const burger = document.querySelector("[data-dune-burger]");
  const nav = document.querySelector(".dune-nav");
  const backdrop = document.querySelector("[data-dune-backdrop]");
  if (!burger || !nav) return;

  function setOpen(open) {
    nav.dataset.open = open ? "true" : "false";
    burger.setAttribute("aria-expanded", open ? "true" : "false");
    burger.setAttribute(
      "aria-label",
      open ? "Fermer le menu" : "Ouvrir le menu"
    );
    if (backdrop) {
      if (open) {
        backdrop.hidden = false;
        requestAnimationFrame(() => (backdrop.dataset.show = "true"));
      } else {
        backdrop.dataset.show = "false";
        setTimeout(() => (backdrop.hidden = true), 300);
      }
    }
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      const firstLink = nav.querySelector("a");
      if (firstLink) firstLink.focus();
    } else {
      burger.focus();
    }
  }

  burger.addEventListener("click", () => {
    setOpen(nav.dataset.open !== "true");
  });
  if (backdrop) {
    backdrop.addEventListener("click", () => setOpen(false));
  }
  nav.querySelectorAll("a").forEach((a) => {
    a.addEventListener("click", () => setOpen(false));
  });
  document.addEventListener("keydown", (e) => {
    if (nav.dataset.open !== "true") return;
    if (e.key === "Escape") setOpen(false);
    if (e.key === "Tab") trapFocus(nav, e);
  });
  const mql = window.matchMedia("(min-width: 768px)");
  mql.addEventListener("change", (e) => {
    if (e.matches) setOpen(false);
  });
}

/* ─── Compte à rebours honnête (vraie date de fin) ───────── */
function initCountdown() {
  const bubble = document.querySelector("[data-promo-end]");
  if (!bubble) return;
  const raw = (bubble.dataset.promoEnd || "").trim();
  const timer = bubble.querySelector("[data-dune-countdown]");
  if (!raw || !timer) {
    if (timer) timer.parentElement === bubble && timer.remove();
    const sub = bubble.querySelector(".dune-promo-bubble__sub");
    if (sub) sub.remove();
    if (timer) timer.remove();
    return;
  }
  const end = new Date(raw.replace(" ", "T"));
  if (isNaN(end.getTime())) {
    timer.remove();
    return;
  }
  const pad = (n) => String(n).padStart(2, "0");
  function update() {
    let diff = end - new Date();
    if (diff <= 0) {
      bubble.remove();
      clearInterval(iv);
      return;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    timer.textContent =
      d > 0 ? `${d}j ${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;
  }
  update();
  const iv = setInterval(update, 1000);
}

/* ─── Recherche prédictive (popup verre) ─────────────────── */
function initSearch() {
  const openBtn = document.querySelector("[data-dune-search-open]");
  const modal = document.querySelector("[data-dune-search]");
  if (!openBtn || !modal) return;
  const input = modal.querySelector("[data-dune-search-input]");
  const results = modal.querySelector("[data-dune-search-results]");
  const allLink = modal.querySelector("[data-dune-search-all]");
  const closeBtn = modal.querySelector("[data-dune-search-close]");
  let lastQuery = "";
  let debounceId = null;

  function setOpen(open) {
    modal.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      requestAnimationFrame(() => (modal.dataset.show = "true"));
      input.focus();
    } else {
      modal.dataset.show = "false";
      openBtn.focus();
    }
  }

  function render(products, query) {
    results.innerHTML = "";
    if (!products.length) {
      results.innerHTML =
        '<p class="dune-search__empty">Aucun résultat pour « ' +
        query.replace(/[<>&]/g, "") +
        " »</p>";
      return;
    }
    products.forEach((p) => {
      const a = document.createElement("a");
      a.className = "dune-search__item";
      a.href = p.url;
      const img = p.featured_image && p.featured_image.url ? p.featured_image.url : "";
      a.innerHTML =
        (img
          ? '<img src="' + img + '&width=120" alt="" width="56" height="70" loading="lazy">'
          : '<span class="dune-search__noimg"></span>') +
        '<span class="dune-search__item-body"><span class="dune-search__item-title">' +
        p.title +
        '</span><span class="dune-search__item-price">' +
        (p.price ? p.price : "") +
        "</span></span>";
      results.appendChild(a);
    });
  }

  function search(query) {
    if (query === lastQuery) return;
    lastQuery = query;
    if (query.length < 2) {
      results.innerHTML = "";
      allLink.hidden = true;
      return;
    }
    const url =
      "/search/suggest.json?q=" +
      encodeURIComponent(query) +
      "&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor";
    fetch(url, { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((data) => {
        const products =
          (data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        render(products, query);
        allLink.href = "/search?q=" + encodeURIComponent(query);
        allLink.hidden = false;
      })
      .catch(() => {});
  }

  openBtn.addEventListener("click", () => setOpen(true));
  if (closeBtn) closeBtn.addEventListener("click", () => setOpen(false));
  modal.addEventListener("click", (e) => {
    if (e.target === modal) setOpen(false);
  });
  input.addEventListener("input", () => {
    clearTimeout(debounceId);
    debounceId = setTimeout(() => search(input.value.trim()), 250);
  });
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && input.value.trim().length >= 2) {
      window.location.href = "/search?q=" + encodeURIComponent(input.value.trim());
    }
  });
  document.addEventListener("keydown", (e) => {
    if (modal.hidden) return;
    if (e.key === "Escape") setOpen(false);
    if (e.key === "Tab") trapFocus(modal, e);
  });
}

/* ─── Skeleton images (anti-CLS) ─────────────────────────── */
function initSkeletons() {
  document.querySelectorAll("img[data-dune-skel]").forEach((img) => {
    const done = () => {
      img.classList.add("is-loaded");
      const media = img.closest("[data-dune-pc-media]");
      if (media) media.classList.add("is-loaded");
    };
    const fail = () => {
      const media = img.closest("[data-dune-pc-media]");
      if (media) media.classList.add("is-loaded", "is-broken");
    };
    if (img.complete && img.naturalWidth > 0) {
      done();
    } else {
      img.addEventListener("load", done, { once: true });
      img.addEventListener("error", fail, { once: true });
    }
  });
}

/* ─── Cartes produit : swatches + ajout rapide ───────────── */
function initProductCards() {
  document.addEventListener("click", (e) => {
    const sw = e.target.closest(".dune-pc__swatch");
    if (sw) {
      e.preventDefault();
      const card = sw.closest("[data-dune-pc]");
      const img = card && card.querySelector("[data-dune-pc-img]");
      if (img && sw.dataset.swapSrc) {
        img.src = sw.dataset.swapSrc;
        if (sw.dataset.swapSrcset) img.srcset = sw.dataset.swapSrcset;
      }
      if (card) {
        card
          .querySelectorAll(".dune-pc__swatch")
          .forEach((s) => s.classList.toggle("is-active", s === sw));
      }
      return;
    }

    const sz = e.target.closest(".dune-pc__size");
    if (sz) {
      e.preventDefault();
      e.stopPropagation();
      if (sz.disabled || sz.classList.contains("is-loading")) return;
      const id = Number(sz.dataset.variantId);
      if (!id) return;
      sz.classList.add("is-loading");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: id, quantity: 1 }),
      })
        .then((r) => {
          if (!r.ok) throw new Error("add");
          return r.json();
        })
        .then(() => {
          sz.classList.remove("is-loading");
          sz.classList.add("is-added");
          setTimeout(() => sz.classList.remove("is-added"), 1500);
          if (window.DUNE && window.DUNE.refreshCart) window.DUNE.refreshCart();
          document.dispatchEvent(new CustomEvent("dune:cart:added"));
        })
        .catch(() => {
          sz.classList.remove("is-loading");
          sz.classList.add("is-error");
          setTimeout(() => sz.classList.remove("is-error"), 1500);
        });
    }
  });
}

/* ─── Guide des tailles : popup verre (contenu = page éditable) ── */
function initSizeGuide() {
  const modal = document.querySelector("[data-dune-sg]");
  if (!modal) return;
  const body = modal.querySelector("[data-dune-sg-body]");
  const closeBtn = modal.querySelector("[data-dune-sg-close]");
  const openers = document.querySelectorAll("[data-dune-sg-open]");
  if (!openers.length) return;
  let loaded = false;

  function setOpen(open) {
    modal.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      requestAnimationFrame(() => (modal.dataset.show = "true"));
      if (!loaded) load();
      closeBtn.focus();
    } else {
      modal.dataset.show = "false";
    }
  }

  function load() {
    loaded = true;
    const url = body.dataset.sgUrl;
    if (!url) return;
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const main =
          doc.querySelector(".dune-sg") ||
          doc.querySelector("main .shopify-section") ||
          doc.querySelector("main");
        body.innerHTML = main ? main.innerHTML : "<p>Voir la page guide des tailles.</p>";
      })
      .catch(() => {
        body.innerHTML =
          '<p>Consultez le <a href="' + body.dataset.sgUrl + '">guide des tailles</a>.</p>';
      });
  }

  openers.forEach((o) => o.addEventListener("click", () => setOpen(true)));
  if (closeBtn) closeBtn.addEventListener("click", () => setOpen(false));
  modal.addEventListener("click", (e) => {
    if (e.target === modal) setOpen(false);
  });
  document.addEventListener("keydown", (e) => {
    if (modal.hidden) return;
    if (e.key === "Escape") setOpen(false);
    if (e.key === "Tab") trapFocus(modal, e);
  });
}

ready(() => {
  initNavScroll();
  initRipples();
  initRevealOnView();
  initCartCount();
  initBurgerNav();
  initCountdown();
  initSearch();
  initSkeletons();
  initProductCards();
  initSizeGuide();
  initFilters();
  initCartDrawer();
});

/* ─── Cart drawer (verre) ────────────────────────────────── */
function initCartDrawer() {
  const drawer = document.querySelector("[data-dune-cart-drawer]");
  if (!drawer) return;
  const itemsEl = drawer.querySelector("[data-dune-cart-items]");
  const emptyEl = drawer.querySelector("[data-dune-cart-empty]");
  const footEl = drawer.querySelector("[data-dune-cart-foot]");
  const subtotalEl = drawer.querySelector("[data-dune-cart-subtotal]");
  const countLabel = drawer.querySelector("[data-dune-cart-count-label]");
  const shipEl = drawer.querySelector("[data-dune-cart-ship]");
  const shipMsg = drawer.querySelector("[data-dune-cart-ship-msg]");
  const shipFill = drawer.querySelector("[data-dune-cart-ship-fill]");
  const closers = drawer.querySelectorAll("[data-dune-cart-close]");
  const moneyFormat = drawer.dataset.moneyFormat || "{{ amount }} €";
  const freeShip = parseFloat(drawer.dataset.freeShip || "0") * 100;
  const recoEl = drawer.querySelector("[data-dune-cart-reco]");
  const recoItemsEl = drawer.querySelector("[data-dune-cart-reco-items]");

  function money(cents) {
    const val = (cents / 100).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return moneyFormat
      .replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/g, val)
      .replace(/\{\{\s*amount_no_decimals(_with_comma_separator)?\s*\}\}/g, Math.round(cents / 100))
      .replace(/<[^>]*>/g, "")
      .trim();
  }

  function setOpen(open) {
    drawer.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      requestAnimationFrame(() => (drawer.dataset.show = "true"));
      render();
      if (closers[0]) closers[0].focus();
    } else {
      drawer.dataset.show = "false";
    }
  }

  function render() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((cart) => {
        if (countLabel) countLabel.textContent = "(" + cart.item_count + ")";
        updateOffer(cart.item_count || 0);
        document.querySelectorAll("[data-dune-cart-count]").forEach((c) => {
          c.textContent = cart.item_count;
          c.hidden = cart.item_count === 0;
        });
        const empty = cart.item_count === 0;
        emptyEl.hidden = !empty;
        footEl.hidden = empty;
        itemsEl.hidden = empty;
        if (shipEl) shipEl.hidden = empty || freeShip <= 0;

        if (!empty && freeShip > 0 && shipMsg) {
          const remaining = freeShip - cart.total_price;
          if (remaining > 0) {
            shipMsg.innerHTML =
              "Plus que <strong>" + money(remaining) + "</strong> pour la livraison offerte";
          } else {
            shipMsg.innerHTML = "🎉 Livraison offerte débloquée !";
          }
          shipFill.style.width = Math.min(100, (cart.total_price / freeShip) * 100) + "%";
        }

        itemsEl.innerHTML = cart.items
          .map(function (it, i) {
            const img = it.image
              ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="" width="72" height="90" loading="lazy">'
              : '<span class="dune-cart-item__noimg"></span>';
            const variant =
              it.variant_title && it.variant_title !== "Default Title"
                ? '<p class="dune-cart-item__variant">' + it.variant_title + "</p>"
                : "";
            // Badge remise : uniquement sur la ligne réellement réduite par Shopify
            const disc = it.total_discount > 0;
            const pct = disc && it.original_line_price ? Math.round((it.total_discount / it.original_line_price) * 100) : 0;
            const promoTag = disc ? ' <span class="dune-cart-item__promo">−' + pct + ' %</span>' : "";
            return (
              '<div class="dune-cart-item" data-line="' + (i + 1) + '">' +
              '<a href="' + it.url + '" class="dune-cart-item__media">' + img + "</a>" +
              '<div class="dune-cart-item__body">' +
              '<a href="' + it.url + '" class="dune-cart-item__title">' + it.product_title + "</a>" +
              variant +
              '<div class="dune-cart-item__row">' +
              '<div class="dune-cart-item__qty">' +
              '<button type="button" aria-label="Diminuer" data-qty-minus>−</button>' +
              '<span data-qty>' + it.quantity + "</span>" +
              '<button type="button" aria-label="Augmenter" data-qty-plus>+</button>' +
              "</div>" +
              '<span class="dune-cart-item__price">' + money(it.final_line_price) + promoTag + "</span>" +
              "</div>" +
              '<button type="button" class="dune-cart-item__remove" data-remove>Retirer</button>' +
              "</div></div>"
            );
          })
          .join("");
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

        // Complétez votre panier : 1 recommandation (basée sur le 1er article)
        if (recoEl && recoItemsEl) {
          if (empty || !cart.items.length) {
            recoEl.hidden = true;
          } else {
            const inCart = cart.items.map(function (it) { return it.product_id; });
            fetch("/recommendations/products.json?product_id=" + cart.items[0].product_id + "&limit=8&intent=related", { headers: { Accept: "application/json" } })
              .then(function (r) { return r.json(); })
              .then(function (data) {
                const recos = (data.products || []).filter(function (p) { return inCart.indexOf(p.id) === -1; }).slice(0, 1);
                if (!recos.length) { recoEl.hidden = true; return; }
                recoItemsEl.innerHTML = recos
                  .map(function (p) {
                    const v = (p.variants || [])[0] || {};
                    const src = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : "";
                    const img = src ? '<img src="' + src + '" alt="" width="52" height="52" loading="lazy">' : "<span></span>";
                    return (
                      '<div class="dune-cart-reco__item">' +
                      '<a href="' + p.url + '" class="dune-cart-reco__media">' + img + "</a>" +
                      '<div class="dune-cart-reco__body">' +
                      '<a href="' + p.url + '" class="dune-cart-reco__title">' + p.title + "</a>" +
                      '<span class="dune-cart-reco__price">' + money(v.price) + "</span>" +
                      "</div>" +
                      '<button type="button" class="dune-cart-reco__add" data-reco-add="' + v.id + '" aria-label="Ajouter au panier">+</button>' +
                      "</div>"
                    );
                  })
                  .join("");
                recoEl.hidden = false;
              })
              .catch(function () { recoEl.hidden = true; });
          }
        }
      })
      .catch(() => {});
  }

  function change(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: qty }),
    })
      .then((r) => r.json())
      .then(() => {
        render();
        if (window.DUNE && window.DUNE.refreshCart) window.DUNE.refreshCart();
      })
      .catch(() => {});
  }

  itemsEl.addEventListener("click", (e) => {
    const item = e.target.closest("[data-line]");
    if (!item) return;
    const line = parseInt(item.dataset.line, 10);
    const qty = parseInt(item.querySelector("[data-qty]").textContent, 10);
    if (e.target.closest("[data-qty-plus]")) change(line, qty + 1);
    else if (e.target.closest("[data-qty-minus]")) change(line, Math.max(0, qty - 1));
    else if (e.target.closest("[data-remove]")) change(line, 0);
  });

  if (recoItemsEl) {
    recoItemsEl.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-reco-add]");
      if (!btn) return;
      const id = Number(btn.getAttribute("data-reco-add"));
      if (!id) return;
      btn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: id, quantity: 1 }),
      })
        .then((r) => r.json())
        .then(() => {
          render();
          if (window.DUNE && window.DUNE.refreshCart) window.DUNE.refreshCart();
        })
        .catch(() => {
          btn.disabled = false;
        });
    });
  }

  document.querySelectorAll(".dune-nav-cart, .dune-mobile-cart").forEach((c) => {
    c.addEventListener("click", (e) => {
      e.preventDefault();
      setOpen(true);
    });
  });
  document.addEventListener("dune:cart:added", () => setOpen(true));

  closers.forEach((c) => c.addEventListener("click", () => setOpen(false)));
  drawer.addEventListener("click", (e) => {
    if (e.target === drawer) setOpen(false);
  });
  document.addEventListener("keydown", (e) => {
    if (drawer.hidden) return;
    if (e.key === "Escape") setOpen(false);
    if (e.key === "Tab") trapFocus(drawer, e);
  });
}

/* ─── Filtres collection : panneau latéral verre ─────────── */
function initFilters() {
  const panel = document.querySelector("[data-dune-filter-panel]");
  const openBtn = document.querySelector("[data-dune-filter-open]");
  if (!panel || !openBtn) return;
  const closeBtn = panel.querySelector("[data-dune-filter-close]");

  function setOpen(open) {
    panel.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      requestAnimationFrame(() => (panel.dataset.show = "true"));
      const firstInput = panel.querySelector("input, button");
      if (firstInput) firstInput.focus();
    } else {
      panel.dataset.show = "false";
      openBtn.focus();
    }
  }
  openBtn.addEventListener("click", () => setOpen(true));
  if (closeBtn) closeBtn.addEventListener("click", () => setOpen(false));
  panel.addEventListener("click", (e) => {
    if (e.target === panel) setOpen(false);
  });
  document.addEventListener("keydown", (e) => {
    if (panel.hidden) return;
    if (e.key === "Escape") setOpen(false);
    if (e.key === "Tab") trapFocus(panel, e);
  });
}

window.DUNE = window.DUNE || {};
window.DUNE.refreshCart = initCartCount;
